import { NUMBERED_KINDS, type NumberedKind } from '../utils/routeRefs';

/**
 * What the router writes into the address bar. Reading is always on: every short address, every project-prefixed
 * address and every old address opens. Writing is switched on kind by kind so a regression can be reverted by editing
 * this list, without touching the pages.
 */
export const routeRefConfig: {
  /** Kinds whose links show `PREFIX-number` instead of `PREFIX-uuid`. */
  encodeKinds: ReadonlySet<NumberedKind>;
  /** Project pages are written as `/project/PJ-x/...`. */
  projectInPath: boolean;
} = {
  encodeKinds: new Set<NumberedKind>(NUMBERED_KINDS),
  projectInPath: false,
};
